// App.js
import { AppVarsProvider } from './context/AppVarsContext';
import AppWithVars from './AppWithVars';

const App = () => {
  const currentHost = window.location.hostname;

  const domainToAppIdMap = {
    'digitaldashboard.donordetectives.com': 'f9de637d-6cb1-11eb-a1e0-0ab31cf82f57',
    'lightwerks.digitalwerks.com': '43833997-5cc0-11eb-97b9-0ab31cf82f57',
    'viewer.reportwerks.com': 'ed03cbb8-9529-4357-8ee1-2fdb14406d73',
    'localhost': 'ed03cbb8-9529-4357-8ee1-2fdb14406d73',
    //'localhost': 'f9de637d-6cb1-11eb-a1e0-0ab31cf82f57',
  };

  const appid = domainToAppIdMap[currentHost] || '43833997-5cc0-11eb-97b9-0ab31cf82f57';

  return (
    <AppVarsProvider appid={appid}>
      <AppWithVars />
    </AppVarsProvider>
  );
};

export default App;